export const UK_CITIES = [
    'Aberdeen, United Kingdom',
    'Armagh, United Kingdom',
    'Bangor, United Kingdom',
    'Bath, United Kingdom',
    'Belfast, United Kingdom',
    'Birmingham, United Kingdom',
    'Bradford, United Kingdom',
    'Brighton and Hove, United Kingdom',
    'Bristol, United Kingdom',
    'Cambridge, United Kingdom',
    'Canterbury, United Kingdom',
    'Cardiff, United Kingdom',
    'Carlisle, United Kingdom',
    'Chelmsford, United Kingdom',
    'Chester, United Kingdom',
    'Chichester, United Kingdom',
    'Coventry, United Kingdom',
    'Derby, United Kingdom',
    'Derry, United Kingdom',
    'Dundee, United Kingdom',
    'Durham, United Kingdom',
    'Edinburgh, United Kingdom',
    'Ely, United Kingdom',
    'Exeter, United Kingdom',
    'Glasgow, United Kingdom',
    'Gloucester, United Kingdom',
    'Hereford, United Kingdom',
    'Inverness, United Kingdom',
    'Kingston upon Hull, United Kingdom',
    'Lancaster, United Kingdom',
    'Leeds, United Kingdom',
    'Leicester, United Kingdom',
    'Lichfield, United Kingdom',
    'Lincoln, United Kingdom',
    'Lisburn, United Kingdom',
    'Liverpool, United Kingdom',
    'Londonderry, United Kingdom',
    'London, United Kingdom',
    'Manchester, United Kingdom',
    'Milton Keynes, United Kingdom',
    'Newcastle upon Tyne, United Kingdom',
    'Newport, United Kingdom',
    'Newry, United Kingdom',
    'Norwich, United Kingdom',
    'Nottingham, United Kingdom',
    'Oxford, United Kingdom',
    'Perth, United Kingdom',
    'Peterborough, United Kingdom',
    'Plymouth, United Kingdom',
    'Portsmouth, United Kingdom',
    'Preston, United Kingdom',
    'Ripon, United Kingdom',
    'Salford, United Kingdom',
    'Salisbury, United Kingdom',
    'Sheffield, United Kingdom',
    'Southampton, United Kingdom',
    'Southend-on-Sea, United Kingdom',
    'St Albans, United Kingdom',
    'St Asaph, United Kingdom',
    'St Davids, United Kingdom',
    'Stirling, United Kingdom',
    'Stoke-on-Trent, United Kingdom',
    'Sunderland, United Kingdom',
    'Swansea, United Kingdom',
    'Truro, United Kingdom',
    'Wakefield, United Kingdom',
    'Wells, United Kingdom',
    'Westminster, United Kingdom',
    'Winchester, United Kingdom',
    'Wolverhampton, United Kingdom',
    'Worcester, United Kingdom',
    'Wrexham, United Kingdom',
    'York, United Kingdom',
]
